module.exports = __webpack_public_path__ + "static/media/appello_icon.ac4641b3.png";